import { CodeResult } from 'views/CustomerFacingDisplay/hardwareAgent/CFDClientEvent'
import { CFDClientMessage } from './types'
export enum CFDOnPOSEvent {
    /**
     * the CFD request the current data display
     */
    OnCFDRequest = 'OnCFDRequest',
    /**
     * the CFD send code to validate
     */
    OnCFDCodeValidate = 'OnCFDCodeValidate',
    /**
     * the CFD send token to validate
     */
    OnCFDTokenValidate = 'OnCFDTokenValidate',
}

export type CFDOnPosEventArg =
    | {
          type: CFDOnPOSEvent.OnCFDRequest
          params: CFDClientMessage
      }
    | {
          type: CFDOnPOSEvent.OnCFDCodeValidate
          params: CodeResult
      }
    | {
          type: CFDOnPOSEvent.OnCFDTokenValidate
          params: CodeResult
      }

export enum CFDInvokeAction {
    /**
     * call when ready to connect with CFD
     */
    ConnectWithCFD = 'ConnectWithCFD',
    /**
     * send the data to display in CFD
     */
    SendMessageToCFD = 'SendMessageToCFD',
    /**
     * call when accept the token or code pairing
     */
    AcceptPairing = 'AcceptPairing',
}
